import React from 'react';
import { ROUTES } from 'constants/routes';
import { NavLink as RouterNavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import useAuthentication from 'hooks/useAuthentication';
import { X_PATH } from 'constants/xPath';
import NavLink from '#web-components/components/Navbar/components/NavLink';
import {
  EmailUnreadIcon, FolderOpenIcon, FolderSharedIcon, GridIcon, InventoryIcon, TaskIcon,
} from '#web-components/components/Icons';
import styles from './NavLinks.styles';

const useStyles = makeStyles(styles, { name: 'HeaderLinks' });

const HEADER_LINKS = [
  {
    title: 'components:header.home',
    path: ROUTES.HOME,
    ariaHidden: 'true',
    icon: <GridIcon />,
  },
  {
    title: 'appSections.myNotifications.title',
    path: ROUTES.NOTIFICATION_LIST,
    icon: <EmailUnreadIcon />,
  },
  {
    title: 'appSections.processDefinition.title',
    path: ROUTES.PROCESS_LIST,
    icon: <FolderOpenIcon />,
  },
  {
    title: 'appSections.processActive.title',
    path: ROUTES.PROCESS_INSTANCE_LIST,
    icon: <FolderSharedIcon />,
  },
  {
    title: 'appSections.task.title',
    path: ROUTES.USER_TASK_LIST,
    icon: <TaskIcon />,
  },
  {
    title: 'appSections.report.title',
    path: ROUTES.REPORTS_LIST,
    icon: <InventoryIcon />,
  },
];

export default function HeaderLinks() {
  const authentication = useAuthentication();
  const location = useLocation();
  const { t } = useTranslation('domains');
  const classes = useStyles();

  if (!(authentication.authenticated)) {
    return null;
  }

  return (
    <div data-xpath={X_PATH.headerLinks}>
      {HEADER_LINKS.map((link) => (
        <Box key={link.path} className={classes.link}>
          <NavLink
            name={t(link.title)}
            icon={link.icon}
            component={RouterNavLink}
            to={link.path}
            selected={location.pathname.startsWith(link.path)}
          />
        </Box>
      ))}
    </div>
  );
}
